// // src/components/ConversationCard.jsx
// import { useState, useRef, useEffect } from "react";
// import { db, doc, updateDoc } from "./firebase";
// import { toast } from "react-toastify";
// import { needAttention as checkNeedAttention } from "./utils/chatHelpers";
// import responderPorCanal from "./utils/responderPorCanal";

// function toMillis(ts) {
//     if (typeof ts === "number") return ts;
//     if (ts?.toMillis) return ts.toMillis();
//     if (ts?.seconds) return ts.seconds * 1000;
//     return 0;
// }

// export default function ConversationCard({ conversation, collectionName }) {
//     const {
//         id,
//         personName,
//         personId,
//         createdAt,
//         lastUpdate,
//         historyChat = [],
//         channel,
//         personFullName,
//         conversationStatus,
//         agentControl = false,
//         senderProfile, // opcional: si lo guardás en el doc, tendrá prioridad
//     } = conversation;

//     /* ───── estado UI ───── */
//     const [showSendModal, setShowSendModal] = useState(false);
//     const [messageText, setMessageText] = useState("");
//     const [showModal, setShowModal] = useState(false);
//     const chatContainerRef = useRef(null);

//     /* ───── scroll automático en historial ───── */
//     useEffect(() => {
//         if (chatContainerRef.current) {
//             chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
//         }
//     }, [historyChat]);

//     /* ───── tiempos / badges ───── */
//     const now = Date.now();
//     const lastMs = toMillis(lastUpdate);
//     const diffLastUpdate = now - lastMs;
//     const badgeRecent = diffLastUpdate < 1_800_000; // 30 min
//     const badgeClass = badgeRecent ? "bg-[#5860D5] text-white" : "bg-[#e91c24] text-white";

//     /* ───── atención ───── */
//     const needAttention = checkNeedAttention(historyChat, agentControl, now);

//     /* ───── bloqueo 24h ───── */
//     const canSend = now - lastMs < 86_400_000;

//     /* ───── perfil de salida (mayorista / consumidor) ───── */
//     const derivedProfile =
//         senderProfile ||
//         (collectionName === "activeUsersConsumidorFinal" ? "consumidor" : "mayorista");

//     /* ───── helpers ───── */
//     const pushMessageToFirestore = async (text, extraFields = {}) => {
//         await updateDoc(doc(db, collectionName, id), {
//             historyChat: [...historyChat, { agent: text, timestamp: Date.now() }],
//             lastUpdate: Date.now(),
//             ...extraFields,
//         });
//     };

//     const handleSend = async ({ takeControl = false } = {}) => {
//         const trimmed = messageText.trim();
//         if (!trimmed || !canSend) return;

//         try {
//             // 1) Guardar en la colección correcta
//             await pushMessageToFirestore(trimmed, takeControl ? { agentControl: true } : {});

//             // 2) Enviar por canal con el perfil correcto
//             const res = await responderPorCanal(channel, personId, trimmed, {
//                 profile: derivedProfile,
//             });

//             if (!res.ok) {
//                 const body = await res.text().catch(() => "");
//                 console.error("Fallo envío canal:", res.status, body);
//                 toast.error("No se pudo enviar por el canal");
//                 return;
//             }

//             setMessageText("");
//             setShowSendModal(false);
//             toast.success("Mensaje enviado correctamente!");
//         } catch (err) {
//             console.error(err);
//             toast.error("Hubo un error al enviar el mensaje");
//         }
//     };

//     /* ───── UI ───── */
//     return (
//         <>
//             {/* Tarjeta */}
//             <div className="card bg-base-100 shadow relative">
//                 {/* Indicador BOT/AGENTE */}
//                 <span
//                     className={`absolute top-2 right-2 badge ${agentControl ? "badge-success" : "badge-secondary"
//                         }`}
//                     title={agentControl ? "Agente en control" : "Bot en control"}
//                 >
//                     {agentControl ? "Agente" : "Bot"}
//                 </span>

//                 <div className="card-body">
//                     <h2 className="card-title">
//                         {personName}

//                         {/* ID badge que abre modal de envío */}
//                         <div
//                             className={`badge ml-2 text-xs cursor-pointer ${badgeClass}`}
//                             onClick={() => setShowSendModal(true)}
//                             title={`Enviar mensaje (salida: ${derivedProfile})`}
//                         >
//                             {personId}
//                         </div>

//                         {/* estado opcional */}
//                         {conversationStatus && (
//                             <div className="badge badge-info ml-2 text-xs">{conversationStatus}</div>
//                         )}

//                         {/* badge “Atención” */}
//                         {needAttention && (
//                             <div className="badge badge-warning ml-2 text-xs animate-pulse">
//                                 Atención
//                             </div>
//                         )}
//                     </h2>

//                     <p className="text-sm text-gray-500">
//                         Creado: {createdAt ? new Date(toMillis(createdAt)).toLocaleString() : "—"}
//                     </p>
//                     <p className="text-sm text-gray-500">
//                         Último: {lastMs ? new Date(lastMs).toLocaleString() : "—"}
//                     </p>

//                     {/* Historial resumido (click = modal completo) */}
//                     <div
//                         ref={chatContainerRef}
//                         className="mt-2 max-h-40 overflow-auto space-y-2 cursor-pointer"
//                         onClick={() => setShowModal(true)}
//                         title="Haz clic para ver la conversación completa"
//                     >
//                         {historyChat?.map((m, i) => {
//                             const isUser = !!m.user;
//                             const isAgent = !!m.agent;
//                             const content = m.user || m.bot || m.agent;
//                             const dateStr = new Date(m.timestamp).toLocaleString();
//                             const sender = isUser ? "Usuario" : isAgent ? "Agente" : "Bot";
//                             return (
//                                 <div
//                                     key={i}
//                                     className={`p-2 rounded-md w-fit max-w-[80%] ${isUser
//                                         ? "bg-blue-50 text-blue-800 ml-auto"
//                                         : isAgent
//                                             ? "bg-green-50 text-green-800 mr-auto"
//                                             : "bg-gray-100 text-gray-800 mr-auto"
//                                         }`}
//                                 >
//                                     <div className="text-xs font-semibold">{sender}</div>
//                                     <div className="text-sm whitespace-pre-wrap">{content}</div>
//                                     <div className="text-xs text-gray-500 text-right mt-1">{dateStr}</div>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 </div>
//             </div>

//             {/* Modal historial completo */}
//             {showModal && (
//                 <div className="modal modal-open">
//                     <div className="modal-box max-w-3xl">
//                         <h3 className="font-bold text-lg mb-4">
//                             Conversación completa: {personFullName}
//                         </h3>

//                         <div className="max-h-[70vh] overflow-auto space-y-3">
//                             {historyChat?.map((m, i) => {
//                                 const isUser = !!m.user;
//                                 const isAgent = !!m.agent;
//                                 const content = m.user || m.bot || m.agent;
//                                 const dateStr = new Date(m.timestamp).toLocaleString();
//                                 const sender = isUser ? "Usuario" : isAgent ? "Agente" : "Bot";
//                                 return (
//                                     <div
//                                         key={i}
//                                         className={`p-3 rounded-md w-fit max-w-[80%] ${isUser
//                                             ? "bg-blue-50 text-blue-800 ml-auto"
//                                             : isAgent
//                                                 ? "bg-green-50 text-green-800 mr-auto"
//                                                 : "bg-gray-100 text-gray-800 mr-auto"
//                                             }`}
//                                     >
//                                         <div className="text-xs font-semibold">{sender}</div>
//                                         <div className="text-sm whitespace-pre-wrap">{content}</div>
//                                         <div className="text-xs text-gray-500 text-right mt-1">{dateStr}</div>
//                                     </div>
//                                 );
//                             })}
//                         </div>

//                         <div className="modal-action">
//                             <button className="btn" onClick={() => setShowModal(false)}>
//                                 Cerrar
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Modal de envío */}
//             {showSendModal && (
//                 <div className="modal modal-open">
//                     <div className="modal-box">
//                         <h3 className="font-bold text-lg mb-4">
//                             Enviar mensaje a {personFullName}
//                         </h3>

//                         <textarea
//                             className="textarea textarea-bordered w-full"
//                             placeholder={`Escribe tu mensaje… (salida: ${derivedProfile})`}
//                             value={messageText}
//                             onChange={(e) => setMessageText(e.target.value)}
//                         />

//                         {!canSend && (
//                             <p className="mt-2 text-sm text-error">
//                                 No se puede enviar mensajes al cliente porque pasaron las 24&nbsp;horas.
//                             </p>
//                         )}

//                         <div className="modal-action">
//                             <button className="btn" onClick={() => setShowSendModal(false)}>
//                                 Cancelar
//                             </button>

//                             <button
//                                 className="btn btn-primary"
//                                 onClick={() => handleSend()}
//                                 disabled={!messageText.trim() || !canSend}
//                                 title={`Guardar en ${collectionName} y enviar por ${derivedProfile}`}
//                             >
//                                 Enviar único
//                             </button>

//                             <button
//                                 className="btn btn-primary"
//                                 onClick={() => handleSend({ takeControl: true })}
//                                 disabled={!messageText.trim() || !canSend}
//                                 title={`Tomar control, guardar y enviar por ${derivedProfile}`}
//                             >
//                                 Enviar y tomar control
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// }


import { useState, useRef, useEffect } from "react";
import { db, doc, updateDoc } from "./firebase";
import { toast } from "react-toastify";
import { needAttention as checkNeedAttention } from "./utils/chatHelpers";
import responderPorCanal from "./utils/responderPorCanal";
import { sendInfobipTemplate } from "./utils/sendInfobipTemplate"; // 👈 nuevo

function toMillis(ts) {
    if (typeof ts === "number") return ts;
    if (ts?.toMillis) return ts.toMillis();
    if (ts?.seconds) return ts.seconds * 1000;
    return 0;
}

export default function ConversationCard({ conversation, collectionName }) {
    const {
        id,
        personName,
        personId,
        createdAt,
        lastUpdate,
        historyChat = [],
        channel,
        personFullName,
        conversationStatus,
        agentControl = false,
        senderProfile, // opcional: si lo guardás en el doc, tendrá prioridad
    } = conversation;

    /* ───── estado UI ───── */
    const [showSendModal, setShowSendModal] = useState(false);
    const [messageText, setMessageText] = useState("");
    const [showModal, setShowModal] = useState(false);
    const chatContainerRef = useRef(null);

    /* ───── scroll automático en historial ───── */
    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    }, [historyChat]);

    /* ───── tiempos / badges ───── */
    const now = Date.now();
    const lastMs = toMillis(lastUpdate);
    const diffLastUpdate = now - lastMs;
    const badgeRecent = diffLastUpdate < 1_800_000; // 30 min
    const badgeClass = badgeRecent ? "bg-[#5860D5] text-white" : "bg-[#e91c24] text-white";

    /* ───── atención ───── */
    const needAttention = checkNeedAttention(historyChat, agentControl, now);

    /* ───── bloqueo 24h ───── */
    const canSend = now - lastMs < 86_400_000;

    /* ───── perfil de salida (mayorista / consumidor) ───── */
    const derivedProfile =
        senderProfile ||
        (collectionName === "activeUsersConsumidorFinal" ? "consumidor" : "mayorista");

    /* ───── helpers ───── */
    const pushMessageToFirestore = async (text, extraFields = {}) => {
        await updateDoc(doc(db, collectionName, id), {
            historyChat: [...historyChat, { agent: text, timestamp: Date.now() }],
            lastUpdate: Date.now(),
            ...extraFields,
        });
    };

    const handleSend = async ({ takeControl = false } = {}) => {
        const trimmed = messageText.trim();
        if (!trimmed || !canSend) return;

        try {
            // 1) Guardar en la colección correcta
            await pushMessageToFirestore(trimmed, takeControl ? { agentControl: true } : {});

            // 2) Enviar por canal con el perfil correcto
            const res = await responderPorCanal(channel, personId, trimmed, {
                profile: derivedProfile,
            });

            if (!res.ok) {
                const body = await res.text().catch(() => "");
                console.error("Fallo envío canal:", res.status, body);
                toast.error("No se pudo enviar por el canal");
                return;
            }

            setMessageText("");
            setShowSendModal(false);
            toast.success("Mensaje enviado correctamente!");
        } catch (err) {
            console.error(err);
            toast.error("Hubo un error al enviar el mensaje");
        }
    };

    const handleSendTemplate = async (templateName) => {
        if (!personId) {
            toast.error("No se encontró el número del cliente (personId)");
            return;
        }

        // from según sección
        const from =
            collectionName === "activeUsersConsumidorFinal"
                ? "5491168404947" // consumidor final
                : "12134250460"; // mayorista

        try {
            const result = await sendInfobipTemplate({
                to: personId,
                from,
                templateName,
                language: "en",
            });

            if (!result.ok) {
                console.error("Error Infobip:", result);
                toast.error(result.error || "No se pudo enviar el template");
                return;
            }

            // Opcional: loguear en Firestore que se envió un template
            await pushMessageToFirestore(`[TEMPLATE ENVIADO] ${templateName}`);

            toast.success("Template enviado correctamente");
            setShowSendModal(false);
        } catch (err) {
            console.error(err);
            toast.error("Hubo un error al enviar el template");
        }
    };

    /* ───── UI ───── */
    return (
        <>
            {/* Tarjeta */}
            <div className="card bg-base-100 shadow relative">
                {/* Indicador BOT/AGENTE */}
                <span
                    className={`absolute top-2 right-2 badge ${agentControl ? "badge-success" : "badge-secondary"
                        }`}
                    title={agentControl ? "Agente en control" : "Bot en control"}
                >
                    {agentControl ? "Agente" : "Bot"}
                </span>

                <div className="card-body">
                    <h2 className="card-title">
                        {personName}

                        {/* ID badge que abre modal de envío */}
                        <div
                            className={`badge ml-2 text-xs cursor-pointer ${badgeClass}`}
                            onClick={() => setShowSendModal(true)}
                            title={`Enviar mensaje (salida: ${derivedProfile})`}
                        >
                            {personId}
                        </div>

                        {/* estado opcional */}
                        {conversationStatus && (
                            <div className="badge badge-info ml-2 text-xs">
                                {conversationStatus}
                            </div>
                        )}

                        {/* badge “Atención” */}
                        {needAttention && (
                            <div className="badge badge-warning ml-2 text-xs animate-pulse">
                                Atención
                            </div>
                        )}
                    </h2>

                    <p className="text-sm text-gray-500">
                        Creado:{" "}
                        {createdAt ? new Date(toMillis(createdAt)).toLocaleString() : "—"}
                    </p>
                    <p className="text-sm text-gray-500">
                        Último: {lastMs ? new Date(lastMs).toLocaleString() : "—"}
                    </p>

                    {/* Historial resumido (click = modal completo) */}
                    <div
                        ref={chatContainerRef}
                        className="mt-2 max-h-40 overflow-auto space-y-2 cursor-pointer"
                        onClick={() => setShowModal(true)}
                        title="Haz clic para ver la conversación completa"
                    >
                        {historyChat?.map((m, i) => {
                            const isUser = !!m.user;
                            const isAgent = !!m.agent;
                            const content = m.user || m.bot || m.agent;
                            const dateStr = new Date(m.timestamp).toLocaleString();
                            const sender = isUser ? "Usuario" : isAgent ? "Agente" : "Bot";
                            return (
                                <div
                                    key={i}
                                    className={`p-2 rounded-md w-fit max-w-[80%] ${isUser
                                        ? "bg-blue-50 text-blue-800 ml-auto"
                                        : isAgent
                                            ? "bg-green-50 text-green-800 mr-auto"
                                            : "bg-gray-100 text-gray-800 mr-auto"
                                        }`}
                                >
                                    <div className="text-xs font-semibold">{sender}</div>
                                    <div className="text-sm whitespace-pre-wrap">{content}</div>
                                    <div className="text-xs text-gray-500 text-right mt-1">
                                        {dateStr}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* Modal historial completo */}
            {showModal && (
                <div className="modal modal-open">
                    <div className="modal-box max-w-3xl">
                        <h3 className="font-bold text-lg mb-4">
                            Conversación completa: {personFullName}
                        </h3>

                        <div className="max-h-[70vh] overflow-auto space-y-3">
                            {historyChat?.map((m, i) => {
                                const isUser = !!m.user;
                                const isAgent = !!m.agent;
                                const content = m.user || m.bot || m.agent;
                                const dateStr = new Date(m.timestamp).toLocaleString();
                                const sender = isUser ? "Usuario" : isAgent ? "Agente" : "Bot";
                                return (
                                    <div
                                        key={i}
                                        className={`p-3 rounded-md w-fit max-w-[80%] ${isUser
                                            ? "bg-blue-50 text-blue-800 ml-auto"
                                            : isAgent
                                                ? "bg-green-50 text-green-800 mr-auto"
                                                : "bg-gray-100 text-gray-800 mr-auto"
                                            }`}
                                    >
                                        <div className="text-xs font-semibold">{sender}</div>
                                        <div className="text-sm whitespace-pre-wrap">
                                            {content}
                                        </div>
                                        <div className="text-xs text-gray-500 text-right mt-1">
                                            {dateStr}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div className="modal-action">
                            <button className="btn" onClick={() => setShowModal(false)}>
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de envío */}
            {showSendModal && (
                <div className="modal modal-open">
                    <div className="modal-box">
                        <h3 className="font-bold text-lg mb-4">
                            Enviar mensaje a {personFullName}
                        </h3>

                        {/* Si se puede enviar mensaje normal → textarea + botones */}
                        {canSend ? (
                            <>
                                <textarea
                                    className="textarea textarea-bordered w-full"
                                    placeholder={`Escribe tu mensaje… (salida: ${derivedProfile})`}
                                    value={messageText}
                                    onChange={(e) => setMessageText(e.target.value)}
                                />

                                <div className="modal-action">
                                    <button
                                        className="btn"
                                        onClick={() => setShowSendModal(false)}
                                    >
                                        Cancelar
                                    </button>

                                    <button
                                        className="btn btn-primary"
                                        onClick={() => handleSend()}
                                        disabled={!messageText.trim()}
                                        title={`Guardar en ${collectionName} y enviar por ${derivedProfile}`}
                                    >
                                        Enviar único
                                    </button>

                                    <button
                                        className="btn btn-primary"
                                        onClick={() => handleSend({ takeControl: true })}
                                        disabled={!messageText.trim()}
                                        title={`Tomar control, guardar y enviar por ${derivedProfile}`}
                                    >
                                        Enviar y tomar control
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <p className="mt-2 text-sm text-error">
                                    No se puede enviar mensajes al cliente porque pasaron las
                                    24&nbsp;horas.
                                </p>
                                <p className="mt-4 text-sm">
                                    Podés iniciar una nueva conversación enviando un template:
                                </p>

                                <div className="mt-4 flex flex-col gap-2">
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() =>
                                            handleSendTemplate(
                                                "nueva_conversacion_phiphitoys"
                                            )
                                        }
                                    >
                                        Enviar template PhiPhiToys
                                    </button>

                                    <button
                                        className="btn btn-outline btn-sm"
                                        onClick={() =>
                                            handleSendTemplate(
                                                "nueva_conversacion_renata"
                                            )
                                        }
                                    >
                                        Enviar template Renata
                                    </button>
                                </div>

                                <div className="modal-action mt-4">
                                    <button
                                        className="btn"
                                        onClick={() => setShowSendModal(false)}
                                    >
                                        Cerrar
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}
